import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem, Input, Label } from 'reactstrap';
import { GetMemberInfoAPI } from '../../helpers/APIS/CommonApisSchema';
import { SelectFullStateOfThisAPI } from '../../Store/callAPI/selectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AssessmentsListPopup = ({ show, onCancel }) => {
    const [selectedAssessment, setSelectedAssessment] = useState(null);
    const navigate = useNavigate();

    const GetMemberInfoAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, GetMemberInfoAPI));
    const assessments = GetMemberInfoAPIData?.response?.data?.assessments || [];

    const handleRadioChange = (assessment) => {
        setSelectedAssessment(assessment);
    };

    const handleContinue = () => {
        if (selectedAssessment) {
            navigate('/assessments', { state: { assessmentData: selectedAssessment } });
            onCancel();
        }
    };

    return (
        <Modal isOpen={show} toggle={onCancel} centered>
            <ModalHeader toggle={onCancel}>Select Assessment</ModalHeader>
            <ModalBody>
                <ListGroup>
                    {assessments.length === 0 && <div>No assessments available.</div>}
                    {assessments.map((assessment) => (
                        <ListGroupItem key={assessment.id} className="d-flex align-items-center border-0">
                            <Input
                                type="radio"
                                name="assessmentRadio"
                                checked={selectedAssessment?.assessmentPlanId === assessment.assessmentPlanId}
                                onChange={() => handleRadioChange(assessment)}
                                className="me-2"
                            />
                            <Label className="mb-0 cursor-pointer" onClick={() => handleRadioChange(assessment)}>
                                {assessment.assessmentName}
                            </Label>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" outline onClick={onCancel}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleContinue} disabled={!selectedAssessment}>
                    Continue
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AssessmentsListPopup;
